{
  "en": {
    "issue": {
      "actions": {
        "approve_for_customer": "Approve for the customer",
        "cancel_approval": "Cancel customer approval",
        "collapse": "Collapse snags",
        "create_category": "Adicionar nova categoria",
        "create_issue": "Create snag",
        "create_issue_customer": "Report defect",
        "delete": "Delete snag",
        "expand": "Expand snags",
        "export_images": "Download images",
        "hideActivity": "Hide activity",
        "hideDetails": "Hide details",
        "openConversation": "Open conversation",
        "reject_for_customer": "Reject for the customer",
        "request_approval": "Request customer approval",
        "show": "Show snag",
        "showActivity": "Show activity",
        "showDetails": "Show details",
        "startConversation": "Start conversation",
        "start_conversation": "Start conversation about this snag",
        "undo_customer_approval": "Undo the customer approval",
        "undo_customer_rejection": "Undo the customer rejection",
        "update": "Update snags"
      },
      "attributes": {
        "approval_status": "Approval customer",
        "assignee": "Assignee",
        "category": "Category",
        "created_at": "Created",
        "deadline": "Deadline",
        "description": "Description",
        "issue_list_type": "Snagging list",
        "name": "Name",
        "responsible": "Responsible",
        "status": "Status",
        "statuses": {
          "approval_not_requested": "Not Requested",
          "approval_requested": "Requested",
          "approved": "Approved",
          "completed": "Completed",
          "created": "Open",
          "declined": "Rejected",
          "inbox": "Sent",
          "not_completed": "Not Completed",
          "ongoing": "Ongoing"
        },
        "updated_at": "Last update"
      },
      "edit_actions": {
        "edit_category": "Category",
        "edit_deadline": "Deadline",
        "edit_issue_list_type": "Snagging list",
        "edit_responsible": "Responsible",
        "edit_status": "Status"
      },
      "labels": {
        "activity": "Show activity",
        "addImagesSubtitle": "A picture says more than a thousand words",
        "addImagesTitle": "Add images to help us understand the defect even better",
        "after_care_page_title": "Your snags",
        "all_categories_can_be_managed_under": "All categories can be managed under",
        "approvalNotRequested": "Approval not requested",
        "approvalRequested": "Approval requested",
        "approved": "Approved",
        "approvedInfo": "Customer approved this snag",
        "assignee": "Assignee",
        "cancelCustomerApproval": "Cancel customer approval request",
        "collapse": "Hide activity",
        "company_settings": "company settings",
        "count_edit": "Edit snag | Edit {count} snags",
        "create_new_category?": "Don't find the category you need? Create a new one!",
        "created_at": "Created at",
        "customerApproved": "Approved by customer",
        "customerRejected": "Rejected by customer",
        "deadline_date": "Deadline",
        "description": "Description",
        "descriptionSubtitle": "Use bullet points and short sentencese to make it easier for us to understand the defect",
        "descriptionTitle": "Give a short description",
        "edit_category": "Edit category",
        "edit_issue": "Edit Snag",
        "isThisPointFixed": "Is this fixed according to you?",
        "issue_category_name": "Category",
        "issue_status_name": "Status",
        "issues_clear_selection": "Clear selection",
        "issues_select_all_pages": "Select all {total} snags",
        "issues_select_one": "Select at least 1 snag",
        "issues_selected": "snags selected",
        "issues_selected_all_pages": "All {total} snags selected",
        "issues_selected_count": "{selected} snag selected | {selected} snags selected",
        "name": "Name",
        "new": "Create new snag",
        "new_category": "New category",
        "noDescriptionYet": "No description yet",
        "no_issue_deadline": "No deadline set",
        "no_issues": "No snags",
        "no_responsible": "No responsible",
        "origin": "Origin",
        "reason": "Reason",
        "redoRequest": "Redo request",
        "requestCustomerApproval": "Request customer approval",
        "requested": "Requested",
        "requestedInfo": "Customer approval requested",
        "resetRequest": "Reset request",
        "responsible_of_Employee_type_last_name_or_responsible_of_Partner_type_last_name": "Responsible",
        "return_to_overview": "Go back",
        "showIssuesfor": "Show snags for",
        "statusExplained": "What does each status color mean",
        "subjectSubtitle": "Only 1 report needed per defect. We take care of the rest",
        "subjectTitle": "Describe the defect in a few words",
        "undoCustomerApproved": "Undo customer approval",
        "unit_issues_will_be_shown_here": "All units attached to the snagging list will be shown here",
        "unit_name": "Unit name",
        "updated_at": "Last update",
        "waitingForApproval": "This snag needs to be accepted by {client_name} first before you can start a conversation",
        "whyIsThisPointNotFixed": "Why is this snag not fixed?",
        "youApprovedThisPoint": "Fixed according to you",
        "youRejectedThisPoint": "Not fixed according to you"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "You will get notified if a new defect gets reported.",
            "title": "No defects reported for your unit yet"
          }
        },
        "employees": {
          "inbox": {
            "subtitle": "When customers create new snags, they'll be shown here again.",
            "title": "You have processed all incoming snags from customers"
          },
          "none": {
            "subtitle": "Start logging what should be fixed or improved",
            "title": "Create your first snag"
          },
          "overview": {
            "subtitle": "Create your first snag inside a unit to get started",
            "title": "Snags created across all your units will be shown here"
          },
          "unit": {
            "title": "All snags for this unit will be shown here"
          }
        },
        "partners": {
          "none": {
            "subtitle": "From the moment you are assigned to snags, they will be visible here",
            "title": "No snags assigned to you yet"
          }
        }
      },
      "sortGroups": {
        "date": "Date",
        "deadline": "Deadline",
        "name": "Name"
      },
      "toasts": {
        "update": "Snag updated"
      },
      "validation": {
        "issue_list_type_required": "Snagging list is required",
        "pleaseProvideAReason": "Please provide a reason",
        "status_required": "Status is required"
      }
    }
  }
}
